// extracted by mini-css-extract-plugin
module.exports = {"base":"styles-m__base__34lHl","bundle-grid":"styles-m__bundle-grid__Y03P4"};